import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdreseCentreComponent } from './adrese-centre.component';
import { AddAdreseCentreComponent } from './add-adrese-centre/add-adrese-centre.component';
import { EditAdreseCentreComponent } from './edit-adrese-centre/edit-adrese-centre.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        AdreseCentreComponent,
        AddAdreseCentreComponent,
        EditAdreseCentreComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [
        AdreseCentreComponent
    ],
})
export class AdreseCentreModule { }
